import React from 'react';
import ReactLoading from 'react-loading';
import './Sloading.css'
 
const SLoader = ({ type, color, text }) => (
    <div className="sloadercontainer">
        <div className="sloadingBox">
            <ReactLoading type={type} color={'#e50000'} height={'70%'} width={'70%'} />
            <span id="Loadingtag">{text}</span>
        </div>
    </div>
);
 
export default SLoader;